/* Maison Byōbu · la popup de bienvenue de la promotion (snippets/mb-offre.liquid), une fois par semaine.
   14/10 (fluidité) : jamais pendant la composition d'un mur. Sur une fiche avec cadreur, elle ne s'ouvre qu'à
   l'intention de sortie sur ordinateur (souris vers le haut de la fenêtre, après 15 s) ; sur les autres pages, après
   15 s ou aux deux tiers de la page. Elle attend toujours qu'aucun champ ne soit en cours de saisie et qu'aucune autre
   fenêtre ne soit ouverte.
   + Ajout au panier : le moteur (mb-cadreur.js) pose aria-busy sur [data-mb-ajouter] pendant l'ajout ; on l'affiche
   (« Ajout à votre panier… ») et on bloque un second clic, qui relancerait l'ajout. Aucun calcul de prix ici. */
(() => {
  const st = document.createElement('style');
  st.textContent = '[data-mb-ajouter][aria-busy="true"]{pointer-events:none;opacity:.88;cursor:progress}'
    + '.mb-ajout-roue{display:inline-block;width:1em;height:1em;margin-right:.55em;vertical-align:-.15em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:mb-ajout-tour .7s linear infinite}'
    + '@keyframes mb-ajout-tour{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.mb-ajout-roue{animation-duration:2s}}'
    /* 14/10 : sur une œuvre sombre (collection Stoïque, fonds noirs), la silhouette encre disparaissait : un liseré clair la détache */
    + '.mb-cadreur__silhouette{opacity:.8;filter:drop-shadow(0 0 1px rgba(255,255,255,.95)) drop-shadow(0 0 4px rgba(255,255,255,.55))}';
  document.head.appendChild(st);
  const suivre = (b) => {
    if (b.dataset.mbSuivi) return;
    b.dataset.mbSuivi = '1';
    const maj = () => {
      if (b.getAttribute('aria-busy') === 'true') {
        if (!b.dataset.mbTexte) { b.dataset.mbTexte = b.innerHTML; b.innerHTML = '<span class="mb-ajout-roue" aria-hidden="true"></span>Ajout à votre panier…'; }
      } else if (b.dataset.mbTexte) { b.innerHTML = b.dataset.mbTexte; delete b.dataset.mbTexte; }
    };
    new MutationObserver(maj).observe(b, { attributes: true, attributeFilter: ['aria-busy'] });
  };
  document.querySelectorAll('[data-mb-ajouter]').forEach(suivre);
  /* 14/10 : œuvres japonaises passées sur la fiche des créations. Shopify refuse les images de plus de 25 Mpx : l'image
     « Motif » de ces quatre œuvres est réduite, mais la limite de taille de mur doit suivre leur vrai fichier d'impression
     (snippets/mb-oeuvre-infos.liquid, champ source). Ce script passe avant mb-cadreur.js, qui lit ces attributs. */
  const SOURCES_IMPRESSION = {
    'vagues-de-matsushima-panorama-complet': '14933x3245',
    'dragons-et-nuages-panorama-complet': '14958x3233',
    'lierre-et-eventails-flottants': '7826x3378',
    'fleurs-printemps-automne': '5883x5431'
  };
  document.querySelectorAll('mb-cadreur[data-oeuvre]').forEach((c) => {
    const s = SOURCES_IMPRESSION[c.dataset.oeuvre];
    if (!s || !c.dataset.sourceL) return;
    const [l, h] = s.split('x');
    c.dataset.sourceL = l; c.dataset.sourceH = h;
  });
  /* Mur au-delà de la taille possible en ligne : plus de « designer » (retiré du site pour Merchant Center). Le moteur
     écrit ces textes ; on ne change que leurs mots, pas le parcours (devis par e-mail). */
  const sansDesigner = (b) => {
    new MutationObserver(() => { if (/au designer/.test(b.textContent)) b.textContent = 'Demander mon devis'; })
      .observe(b, { childList: true, characterData: true, subtree: true });
  };
  document.querySelectorAll('[data-mb-ajouter]').forEach(sansDesigner);
  /* 14/10 (Marcel) : la silhouette de 1,75 m est visible d'emblée dans « Votre mur », pour juger l'échelle de l'œuvre.
     Le bouton « Silhouette 1,75 m » la masque toujours (assets/mb-achat-etapes.js lit data-echelle sur l'aside). */
  document.querySelectorAll('mb-cadreur .mb-cadreur__vivant').forEach((a) => {
    a.setAttribute('data-echelle', '');
    const b = a.closest('mb-cadreur').querySelector('[data-mb-echelle]');
    if (b) b.setAttribute('aria-pressed', 'true');
  });
  if (window.customElements) customElements.whenDefined('mb-cadreur').then(() => {
    const C = customElements.get('mb-cadreur');
    if (C && C.prototype.texteLimite) C.prototype.texteLimite = function () {
      return 'Pour un mur de cette taille, nous préparons votre fichier sur mesure&nbsp;: <a class="mb-lien" href="mailto:'
        + (this.dataset.mail || '') + '" data-mb-ecrire>écrivez-nous</a>. Nous vous répondons avec un devis pour votre mur.';
    };
  });
  addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('[data-mb-ajouter][aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
  });
})();
/* 16/10 (chantier vente) : « −30 % sur votre 2e projet », PRÉPARÉ, INACTIF. Interrupteur unique : data-projet2-actif
   sur [data-mb-offre] (snippets/mb-offre.liquid), à passer à "true" seulement le jour où la remise automatique Shopify
   « 2e projet — 30 % sur le moins cher » (Achetez 1 obtenez 1, collection Tous les papiers peints) est active, cumulable
   avec la promotion. Affichage seulement, comme Shopify : −30 % sur UN mur, le moins cher, dès 2 murs.
   data-projet2-calcul : "sequentiel" (30 % du prix après la promo) ou "original" (30 % du prix plein) — à régler sur le
   résultat réel du panier Shopify au premier test (rapport offres du 16/10). Les remises « Deux murs » et « Trois œuvres »
   sont désactivées dans l'admin depuis le 16/10 13 h 45 (lot B) : elles sortent de window.mbRemises dans tous les cas
   (16/10 passe 2, relecture), qu'il y ait ou non le 2e projet. Restent : promo produit, BIENVENUE10, Tarif grands murs. */
(() => {
  const lire = () => { const r = document.querySelector('[data-mb-offre]'); return r ? r.dataset : {}; };
  window.mbProjet2 = {
    actif: () => lire().projet2Actif === 'true',
    pct: () => Number(lire().projet2Pct) || 30,
    /* murs : [{ centimes (prix unitaire plein tarif), quantite }] ; promoPct : la promo appliquée ligne à ligne (0 sinon) */
    montant(murs, promoPct = 0) {
      if (!this.actif() || !Array.isArray(murs)) return 0;
      const nb = murs.reduce((s, m) => s + (m.quantite || 1), 0);
      if (nb < 2) return 0;
      const c = Math.min(...murs.map((m) => m.centimes));
      const apresPromo = c - Math.floor((c * promoPct) / 100);
      const base = lire().projet2Calcul === 'original' ? c : apresPromo;
      return Math.floor((base * this.pct()) / 100);
    }
  };
  /* Le tableau reste non vide : le moteur lit MB_REMISES_MURS[0] (phrase du palier suivant). Une entrée inatteignable
     (99 murs, 0 %) neutralise « Deux murs » et « Trois œuvres » sans toucher à mb-cadreur.js. */
  const retirerMurs = () => {
    const R = window.mbRemises;
    if (!R || !Array.isArray(R.murs) || (R.murs.length === 1 && R.murs[0].murs === 99)) return;
    R.murs.splice(0, R.murs.length, { murs: 99, pct: 0, nom: '' });
    const st = document.createElement('style'); // la liste « Vos avantages » de mb-achat-etapes.js n'affiche pas l'entrée neutre
    st.textContent = '[data-mb-avantages-liste] li:is([data-cle=""],[data-cle="Deux murs"],[data-cle="Trois œuvres"]){display:none!important}';
    document.head.appendChild(st);
  };
  retirerMurs();
  /* Le récapitulatif « Votre projet » du moteur (window.mbDevis, déjà enveloppé par la promo dans mb-offre.js) */
  const envelopper = () => {
    retirerMurs(); // mb-cadreur.js peut se charger après ce fichier : on réessaie à chaque passage
    const P = window.mbProjet2, orig = window.mbDevis;
    if (!P.actif() || typeof orig !== 'function' || orig.mbProjet2) return;
    const O = window.mbOffre;
    if (O && O.active && O.active() && !orig.mbOffre) return; // attendre l'enveloppe de la promo
    retirerMurs();
    const enveloppe = function (murs, autres = 0) {
      const r = orig(murs, autres);
      const promoPct = O && O.active && O.active() ? O.pct : 0;
      const p2 = P.montant(murs, promoPct);
      if (!p2 || !r) return r;
      const promo = promoPct ? murs.reduce((s, m) => s + Math.floor((m.centimes * promoPct) / 100) * m.quantite, 0) : 0;
      const montant = promo + p2;
      if (r.remise && r.remise.montant >= montant) return r;
      return Object.assign({}, r, { remise: { nom: promo ? 'Promotion + 2e projet' : '2e projet', pct: Math.round((montant / r.sousTotal) * 100), montant }, total: r.sousTotal - montant });
    };
    enveloppe.mbProjet2 = true; enveloppe.mbOffre = true;
    window.mbDevis = enveloppe;
  };
  envelopper();
  document.addEventListener('DOMContentLoaded', envelopper);
  setInterval(envelopper, 1000);
})();
(() => {
  const racine = document.querySelector('[data-mb-offre]');
  if (!racine || !window.mbOffre || !window.mbOffre.active()) return;
  const code = racine.dataset.code;
  const dlg = document.querySelector('[data-mb-bienvenue]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const lire = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const ecrire = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  const ouvrir = () => { if (!dlg.open) { dlg.showModal(); ecrire('mb_bienvenue_vu', String(Date.now())); } };
  const fermer = () => { if (dlg.open) dlg.close(); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mb-bienvenue-ouvrir]')) { e.preventDefault(); ouvrir(); }
    if (e.target.closest('[data-mb-bienvenue-fermer]')) fermer();
  });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) fermer(); });
  const dejaVu = Number(lire('mb_bienvenue_vu') || 0);
  const aLeCode = lire('mb_bienvenue_code') === '1';
  if (aLeCode) { dlg.querySelector('[data-mb-bienvenue-form]').hidden = true; dlg.querySelector('[data-mb-bienvenue-code]').hidden = false; }
  const pageCalme = !/^\/(cart|checkout|account)/.test(location.pathname);
  if (pageCalme && !aLeCode && Date.now() - dejaVu > 7 * 864e5) {
    let fait = false;
    const occupe = () => {
      const a = document.activeElement;
      if (a && (a.matches('input, textarea, select, [contenteditable="true"]') || a.closest('[role="spinbutton"]'))) return true;
      if (document.querySelector('dialog[open]')) return true;
      return false;
    };
    const declencher = () => {
      if (fait) return;
      if (occupe()) { setTimeout(declencher, 3000); return; }
      fait = true; ouvrir();
    };
    const debut = Date.now();
    if (document.querySelector('mb-cadreur')) {
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', (e) => {
          if (!e.relatedTarget && e.clientY <= 0 && Date.now() - debut > 15000) declencher();
        });
      }
    } else {
      setTimeout(declencher, 15000);
      const mi = () => { if (window.scrollY + innerHeight > document.documentElement.scrollHeight * 0.66) { removeEventListener('scroll', mi); declencher(); } };
      addEventListener('scroll', mi, { passive: true });
    }
  }
  const form = dlg.querySelector('[data-mb-bienvenue-form]');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const champ = form.querySelector('input[type=email]');
    const err = form.querySelector('[data-mb-bienvenue-erreur]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(champ.value.trim())) { err.hidden = false; champ.focus(); return; }
    err.hidden = true;
    const fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', champ.value.trim()); fd.append('contact[tags]', 'newsletter, invitations, bienvenue-popup');
    try { await fetch('/contact#mb-bienvenue', { method: 'POST', body: fd, credentials: 'same-origin' }); } catch (x) {}
    try { await fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }); } catch (x) {}
    ecrire('mb_bienvenue_code', '1');
    form.hidden = true;
    dlg.querySelector('[data-mb-bienvenue-code]').hidden = false;
    /* 17/10 (passe récompenses) : la fiche coche son −10 %, le panier se recharge */
    document.dispatchEvent(new CustomEvent('mb:bienvenue'));
  });
})();
/* 14/10 (Marcel) : « Vos avantages exclusifs » remplace l'encart de la promotion, sur la fiche et au panier.
   Les deux avantages en escalier : 1. la promotion (déjà déduite), 2. le code de bienvenue (dès son seuil, remises
   déduites), puis l'économie totale. Affichage seulement : les montants viennent du moteur (tarifImprime, enveloppé par
   mb-offre.js) sur la fiche, et de /cart.js au panier. Le code se calcule comme Shopify (pourcentage tronqué au centime).
   Règles Shopify (admin, 14/10) : la promotion est une remise produit qui se cumule avec le code ; le tarif grands murs est
   une remise commande qui ne se cumule avec rien. Shopify garde la meilleure combinaison : avec le code, promotion + code
   (−23,5 %) bat toujours le tarif grands murs (−20 % au plus). Au panier, aucun montant estimé : avant le code, un bouton
   l'applique et les montants affichés sont ceux de Shopify. */
(() => {
  const racine = document.querySelector('[data-mb-offre]');
  if (!racine || !window.mbOffre || !window.mbOffre.active()) return;
  const O = window.mbOffre;
  const seuil = O.codeSeuil * 100;
  const fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const e = (c) => fmt.format(c / 100);
  const m = (cm) => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(cm / 100);
  const svg = (p) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
  const ICO = {
    coche: svg('<path d="M20 6 9 17l-5-5"/>'),
    cadeau: svg('<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/>'),
    fete: svg('<path d="M5.8 11.3 2 22l10.7-3.79"/><path d="M4 3h.01"/><path d="M22 8h.01"/><path d="M15 2h.01"/><path d="M22 20h.01"/><path d="m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10"/><path d="m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11-.11.7-.72 1.22-1.43 1.22H17"/><path d="m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7"/><path d="M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z"/>'),
    horloge: svg('<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>')
  };
  const st = document.createElement('style');
  st.textContent = [
    '.mb-av-hote{background:none!important;border:0!important;padding:0!important;box-shadow:none!important;display:block!important}',
    '.mb-av-hote::before,.mb-av-hote::after{display:none!important}',
    '.mb-av-hote>:not(.mb-av):not(.mb-offre-encart__livraison){display:none!important}',
    '.mb-av-hote .mb-offre-encart__livraison{margin:12px 2px 0}',
    'html.mb-av-on .mb-offre-panier-eco{display:none!important}',
    '.mb-av{background:var(--mb-blanc,#fff);border:1px solid var(--mb-filet-doux,#E5E5EA);border-radius:20px;padding:20px 20px 16px;color:var(--mb-encre,#272018);font-variant-numeric:tabular-nums;text-align:left}',
    '.mb-av__tete{margin:0 0 6px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:var(--mb-gris,#6B665E)}',
    '.mb-av__etape{display:grid;grid-template-columns:44px 1fr auto;gap:0 14px;align-items:start;padding:14px 0}',
    '.mb-av__etape+.mb-av__etape{border-top:1px solid var(--mb-filet-doux,#E5E5EA)}',
    '.mb-av__ico{width:44px;height:44px;border-radius:12px;background:#EAF2EC;color:#417153;display:grid;place-items:center}',
    '.mb-av__ico svg{width:22px;height:22px}',
    '.mb-av__titre{margin:2px 0 4px;font-size:17px;font-weight:600;line-height:1.3}',
    '.mb-av__code{margin:0 0 4px;font-size:15px}',
    '.mb-av__code b{letter-spacing:.02em}',
    '.mb-av__prix{margin:0;display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 10px}',
    '.mb-av__prix s{color:var(--mb-gris,#6B665E);font-size:15px}',
    '.mb-av__prix b{font-size:22px;font-weight:700}',
    '.mb-av__note{margin:4px 0 0;font-size:14px;color:var(--mb-gris,#6B665E)}',
    '.mb-av__pastille{margin-top:2px;padding:4px 10px;border-radius:980px;background:#EAF2EC;color:#2c5039;font-size:13px;font-weight:600;white-space:nowrap}',
    '.mb-av__etape[data-attente] .mb-av__ico,.mb-av__etape[data-attente] .mb-av__pastille{background:#F2F2F4;color:var(--mb-gris,#6B665E)}',
    '.mb-av__total{margin:6px 0 0;padding:18px 16px;border-radius:16px;background:#F3F7F4;text-align:center}',
    '.mb-av__total svg{display:block;margin:0 auto;width:26px;height:26px;color:#417153}',
    '.mb-av__total-titre{margin:6px 0 2px;font-size:16px}',
    '.mb-av__total-montant{margin:0;font-size:36px;font-weight:700;line-height:1.15;color:#417153}',
    '.mb-av__total-detail{margin:6px 0 0;font-size:14px;color:var(--mb-gris,#6B665E)}',
    '.mb-av__fin{margin:14px 0 0;display:flex;gap:8px;align-items:flex-start;font-size:14px}',
    '.mb-av__fin svg{flex:none;width:18px;height:18px;margin-top:1px;color:var(--mb-gris,#6B665E)}',
    '.mb-av__fin b{font-weight:600;white-space:nowrap}',
    '.mb-av__pour{margin:8px 0 0;font-size:13px;color:var(--mb-gris,#6B665E)}',
    '.mb-av__appliquer{margin-top:10px;padding:9px 16px;border-radius:980px;border:1px solid #417153;background:#fff;color:#2c5039;font:inherit;font-size:14px;font-weight:600;cursor:pointer}',
    '.mb-av__appliquer:hover{background:#EAF2EC}',
    '.mb-av__appliquer[aria-busy="true"]{opacity:.6;pointer-events:none}',
    '.mb-avm__ligne{margin:0;display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 10px}',
    '.mb-avm__prix{font-size:28px;font-weight:700;line-height:1.2;color:#1a1a1a}',
    '.mb-avm__barre{font-size:17px;color:rgba(26,26,26,.5)}',
    '.mb-avm__eco{display:inline-block;margin:8px 0 0;padding:4px 10px;border-radius:980px;background:#417153;color:#fff;font-size:13px;font-weight:700}',
    '.mb-avm__code{margin:14px 0 0;display:flex;justify-content:space-between;align-items:center;gap:12px;padding:12px 14px;border-radius:8px;background:#272018;color:#fff;font-size:14px;line-height:1.35}',
    '.mb-avm__code b{font-weight:700}',
    '.mb-avm__code-prix{font-size:17px;font-weight:700;white-space:nowrap}',
    '.mb-avm__fin{margin:10px 0 0;font-size:13px;color:#6b6b6b}',
    '.mb-avm__fin b{font-weight:600;color:#1a1a1a;white-space:nowrap}',
    '.mbr-fiche__prix{margin:0;display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 10px}',
    '.mbr-fiche__prix b{font-size:32px;line-height:1.1;font-weight:700;letter-spacing:-.01em;color:#1d1d1f}',
    '.mbr-fiche__prix s{font-size:16px;color:rgba(29,29,31,.45)}',
    '.mb-av .mbr-eco{margin:10px 0 0}',
    '.mbr-av{list-style:none;margin:16px 0 0;padding:14px;border:1px solid #E6E2DA;border-radius:12px;display:grid;gap:12px}',
    '.mbr-av li{display:flex;gap:10px;align-items:flex-start;font-size:15px;line-height:1.35;margin:0}',
    '.mbr-av__txt{flex:1}',
    '.mbr-av__txt small{display:block;color:#6B665E;font-size:13px;margin-top:2px}',
    '.mbr-av__mt{font-weight:700;color:#417153;white-space:nowrap}',
    '.mbr-av__activer{appearance:none;border:1.5px solid #417153;background:#fff;color:#2c5039;font:700 14px/1 inherit;padding:8px 12px;border-radius:6px;cursor:pointer;white-space:nowrap}',
    '.mbr-av__activer:hover{background:#EAF2EC}',
    '.mb-av .mbr-fin{margin:14px 0 0}',
    '.mbr-fiche__note{margin:10px 0 0;font-size:13px;color:#6B665E}',
    '@media (max-width:480px){.mb-av{padding:16px 14px 14px}.mb-av__etape{grid-template-columns:38px 1fr auto;gap:0 10px}.mb-av__ico{width:38px;height:38px}.mb-av__total-montant{font-size:30px}}'
  ].join('');
  document.head.appendChild(st);
  document.documentElement.classList.add('mb-av-on');

  /* Les montants, en centimes : base (avant toute remise), auto (remise automatique), code (BIENVENUE10) */
  const carte = (d) => {
    const apres1 = d.base - d.auto;
    const codeOk = d.codeApplique || (d.lieu === 'fiche' && apres1 >= seuil);
    const code = d.codeApplique ? d.code : codeOk ? Math.floor((apres1 * O.codePct) / 100) : 0;
    const final = apres1 - code;
    const nomAuto = d.nomAuto || (d.grandsMurs ? `Tarif grands murs` : 'Votre offre Maison');
    let etape2;
    if (codeOk) {
      etape2 = `<p class="mb-av__prix"><s>${e(apres1)}</s><b>${e(final)}</b></p><p class="mb-av__note">${e(code)} de réduction supplémentaire</p>`;
    } else if (d.lieu === 'panier') {
      etape2 = `<p class="mb-av__note">−${O.codePct}&nbsp;% de plus dès ${O.codeSeuil}&nbsp;€ d’achat, remises déduites.</p><button type="button" class="mb-av__appliquer" data-mb-av-appliquer>Appliquer mon code</button>`;
    } else {
      etape2 = `<p class="mb-av__note">S’ajoute dès ${O.codeSeuil}&nbsp;€ d’achat, remises déduites. Plus que ${e(seuil - apres1)}.</p>`;
    }
    return `<p class="mb-av__tete">Vos avantages exclusifs</p>
      <div class="mb-av__etape">
        <span class="mb-av__ico">${ICO.coche}</span>
        <div><p class="mb-av__titre">1. ${nomAuto}</p>
          <p class="mb-av__prix"><s>${e(d.base)}</s><b>${e(apres1)}</b></p>
          <p class="mb-av__note">${e(d.auto)} de remise déjà appliquée</p>${d.sansCode ? `<p class="mb-av__note">${d.sansCode}</p>` : ''}</div>
        <span class="mb-av__pastille">−${d.pctAuto}&nbsp;%</span>
      </div>
      <div class="mb-av__etape"${codeOk ? '' : ' data-attente'}>
        <span class="mb-av__ico">${ICO.cadeau}</span>
        <div><p class="mb-av__titre">2. Votre cadeau de bienvenue</p>
          <p class="mb-av__code">Code <b>${O.code}</b></p>${etape2}</div>
        <span class="mb-av__pastille">−${O.codePct}&nbsp;%</span>
      </div>
      <div class="mb-av__total">${ICO.fete}
        <p class="mb-av__total-titre">Au total, vous économisez</p>
        <p class="mb-av__total-montant">${e(d.base - final)}</p>
        <p class="mb-av__total-detail">${d.lieu === 'panier' ? 'Votre panier' : d.nb > 1 ? 'Votre projet' : 'Votre création'} à ${e(final)}${d.lieu === 'fiche' && codeOk ? ' avec le code' : ''} au lieu de ${e(d.base)}</p>
      </div>
      <p class="mb-av__fin">${ICO.horloge}<span>Profitez de ces avantages avant la fin de l’offre. Fin dans <b data-mb-offre-reste></b></span></p>
      ${d.pour ? `<p class="mb-av__pour">${d.pour}</p>` : ''}`;
  };
  /* 17/10 (Marcel : « on comprend rien ») : sur la fiche, la carte ne parle que du mur affiché, trois prix au plus
     (prix barré, prix avec l'offre déjà appliquée, prix avec le code). Le seuil du code reste celui du projet entier
     (panier + ce mur), comme Shopify. Le total du projet reste au panier, avec les montants réels de Shopify. */
  /* 17/10 soir, passe récompenses (maquette claude-maquette-recompenses.html validée par Marcel) : le prix final en grand
     et l'ancien barré, « Vous économisez », puis la liste des avantages : gagné = rond vert coché, à débloquer = rond
     vide. Le −10 % de bienvenue s'active par la fenêtre e-mail (bouton « Activer »), puis se coche tout seul dès le
     seuil du projet. Montants tronqués au centime, comme Shopify (vérifié le 17/10 : 10 % de 738,99 € = 73,89 €). Au
     panier, Shopify répartit la remise du code entre les lignes : une ligne peut alors différer d'un centime de son propre
     calcul, mais le total du panier, lui, est celui de Shopify (snippets/mb-remise-panier.liquid). */
  const R2 = window.mbRecompenses || { coche: () => '', aLeCode: () => false };
  const seuilLiv = Number(racine.dataset.seuilLiv || 0) * 100;
  const carteMur = (d) => {
    const apres1 = d.base - d.auto;
    const recu = d.recu;
    const codeOk = recu && d.projetApres1 >= seuil;
    const code = codeOk ? Math.floor((apres1 * O.codePct) / 100) : 0;
    const final = apres1 - code;
    const projetFinal = d.projetApres1 - (codeOk ? Math.floor((d.projetApres1 * O.codePct) / 100) : 0);
    const livOk = seuilLiv > 0 && projetFinal >= seuilLiv;
    const nomAuto = d.nomAuto || `Offre de lancement −${O.pct}&nbsp;%`;
    const liv = seuilLiv > 0 ? (livOk
      ? `<li>${R2.coche(true)}<span class="mbr-av__txt">Livraison offerte</span><b class="mbr-av__mt">offerte</b></li>`
      : `<li>${R2.coche(false)}<span class="mbr-av__txt">Livraison offerte<small>Dès ${seuilLiv / 100}&nbsp;€ d’achat, plus que ${e(seuilLiv - projetFinal)}</small></span></li>`) : '';
    const dix = codeOk
      ? `<li>${R2.coche(true)}<span class="mbr-av__txt">−${O.codePct}&nbsp;% de bienvenue appliqué<small>Sur votre première commande</small></span><b class="mbr-av__mt">−${e(code)}</b></li>`
      : recu
        ? `<li>${R2.coche(false)}<span class="mbr-av__txt">−${O.codePct}&nbsp;% de bienvenue activé<small>S’ajoute dès ${O.codeSeuil}&nbsp;€ d’achat, plus que ${e(seuil - d.projetApres1)}</small></span></li>`
        : `<li>${R2.coche(false)}<span class="mbr-av__txt">−${O.codePct}&nbsp;% de bienvenue<small>Sur votre première commande</small></span><button type="button" class="mbr-av__activer" data-mb-bienvenue-ouvrir>Activer</button></li>`;
    return `<p class="mbr-fiche__prix"><b>${e(final)}</b><s>${e(d.base)}</s></p>
      <p class="mbr-eco">Vous économisez <b>${e(d.base - final)}</b></p>
      <ul class="mbr-av">
        <li>${R2.coche(true)}<span class="mbr-av__txt">${nomAuto} appliquée</span><b class="mbr-av__mt">−${e(d.auto)}</b></li>
        ${liv}${dix}
      </ul>
      ${d.note ? `<p class="mbr-fiche__note">${d.note}</p>` : ''}
      <p class="mbr-fin" data-mbr-offre hidden><span>Fin de l’offre</span><span class="mbr-compteur" data-mbr-compteur></span></p>
      ${d.pour ? `<p class="mbr-fiche__note">${d.pour}</p>` : ''}`;
  };
  const poser = (encart, d) => {
    encart.classList.add('mb-av-hote');
    let av = encart.querySelector(':scope > .mb-av');
    if (!av) { av = document.createElement('div'); av.className = 'mb-av'; encart.prepend(av); }
    const cle = JSON.stringify(d);
    if (av.dataset.cle === cle) return;
    av.dataset.cle = cle;
    const reste = av.querySelector('[data-mb-offre-reste]');
    av.innerHTML = d.mur ? carteMur(d) : carte(d);
    if (reste) av.querySelector('[data-mb-offre-reste]').textContent = reste.textContent;
  };

  /* La fiche — 15/10 (Marcel) : le parcours commence sans prix et se termine par cette carte, à la place du total
     (étape 5, .mb-final). Elle couvre tout le projet : les murs déjà au panier (panierMurs du moteur) + ce mur.
     Mur hors limite (devis) ou mur pas encore saisi : pas de carte. Affichage seulement, aucun prix modifié. */
  const fiche = () => {
    const encart = document.querySelector('.mb-offre-encart[data-lieu="fiche"]');
    const c = document.querySelector('mb-cadreur');
    if (!encart || !c || typeof c.tarifImprime !== 'function') return;
    const fin = c.querySelector('.mb-final');
    if (fin && encart.parentElement !== fin) fin.insertBefore(encart, fin.querySelector('.mb-final__prix') || null);
    const cacher = () => { encart.style.display = 'none'; c.classList.remove('mb-carte-ok'); };
    if (c.dataset.etat !== 'pret' || !c.imp || c.horsLimite) return cacher();
    const prixM2 = c.matiere && c.matiere.centimes ? c.matiere.centimes / 100 : undefined;
    const t = c.tarifImprime(c.imp.w, c.imp.h, prixM2);
    if (!t || !t.centimes) return cacher();
    const murs = [...(Array.isArray(c.panierMurs) ? c.panierMurs : []), ...(c.ajoute ? [] : [{ centimes: t.centimes, quantite: 1 }])];
    const nb = murs.reduce((s, x) => s + (x.quantite || 1), 0);
    const base = murs.reduce((s, x) => s + x.centimes * (x.quantite || 1), 0);
    /* Avec le code, Shopify retient toujours promotion + code (vérifié au panier, y compris au-delà de 2 500 €) ;
       la promotion se calcule ligne à ligne, comme mbDevis (mb-offre.js) */
    const promo = murs.reduce((s, x) => s + Math.floor((x.centimes * O.pct) / 100) * (x.quantite || 1), 0);
    if (!base || !promo) return cacher();
    /* 2e projet (inactif tant que data-projet2-actif n'est pas "true") : −30 % sur le mur le moins cher, en plus de la promo */
    const p2 = window.mbProjet2 ? window.mbProjet2.montant(murs, O.pct) : 0;
    /* Sans code : la meilleure remise commande encore active (Tarif grands murs), si elle bat la promotion */
    const R = window.mbRemises || {};
    let alt = null;
    for (const r of R.murs || []) if (nb >= r.murs && (!alt || r.pct > alt.pct)) alt = { pct: r.pct, nom: r.nom };
    for (const p of R.paliers || []) if (base >= p.seuil && (!alt || p.pct > alt.pct)) alt = { pct: p.pct, nom: 'Tarif grands murs' };
    const sansCode = alt && alt.pct > O.pct ? `Sans le −${O.codePct}&nbsp;% de bienvenue, c’est la remise « ${alt.nom} » (−${alt.pct}&nbsp;%) qui s’appliquerait à la place : ${e(base - Math.floor((base * alt.pct) / 100))}.` : '';
    const matiere = c.matiere ? c.matiere.nom : '';
    const pour = nb > 1 ? `Pour vos ${nb} œuvres, dont ce mur de ${m(c.L)} × ${m(c.H)} m.` : `Pour votre mur de ${m(c.L)} × ${m(c.H)} m${matiere ? `, en ${matiere}` : ''}.`;
    if (!p2 && !sansCode) {
      /* Le seuil du code se juge sur le projet sans compter ce mur deux fois : s'il est déjà au panier (même œuvre,
         reconnue par son titre comme dans lirePanier), on ne l'ajoute pas. Plus de phrase sur le panier (17/10, Marcel). */
      const titre = ((document.querySelector('meta[property="og:title"]') || {}).content || '').replace(/ — /g, ', ');
      const auPanier = Array.isArray(c.panierMurs) ? c.panierMurs : [];
      const dejaLa = c.ajoute || auPanier.some((l) => l.nom === titre);
      const projet = [...auPanier, ...(dejaLa ? [] : [{ centimes: t.centimes, quantite: 1 }])];
      const projetApres1 = projet.reduce((s, x) => s + (x.centimes - Math.floor((x.centimes * O.pct) / 100)) * (x.quantite || 1), 0);
      poser(encart, { lieu: 'fiche', mur: true, base: t.centimes, auto: Math.floor((t.centimes * O.pct) / 100), projetApres1, recu: R2.aLeCode(), pour: `Ce mur : ${m(c.L)} × ${m(c.H)} m.` });
      encart.style.display = '';
      c.classList.add('mb-carte-ok');
      return;
    }
    poser(encart, { lieu: 'fiche', mur: true, base, auto: promo + p2, projetApres1: base - promo - p2, recu: R2.aLeCode(), nomAuto: p2 ? `Offre de lancement et 2e projet −${Math.round(((promo + p2) / base) * 100)}&nbsp;%` : '', note: p2 ? '' : sansCode, pour });
    encart.style.display = '';
    c.classList.add('mb-carte-ok');
  };

  /* Le panier : les remises réellement appliquées par Shopify */
  let panier = null;
  const lirePanier = async () => {
    if (!document.querySelector('.mb-offre-encart[data-lieu="panier"]')) return;
    try { panier = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()); } catch (x) { return; }
  };
  const panierCarte = () => {
    const encart = document.querySelector('.mb-offre-encart[data-lieu="panier"]');
    if (!encart || !panier) return;
    const retirer = () => { encart.classList.remove('mb-av-hote'); encart.querySelector(':scope > .mb-av')?.remove(); };
    if (!panier.items || !panier.items.length) { retirer(); return; }
    let base = 0, auto = 0, code = 0;
    const titres = new Set();
    for (const it of panier.items) {
      base += it.original_line_price;
      for (const a of it.line_level_discount_allocations || []) {
        const app = a.discount_application || {};
        if (app.type === 'discount_code') code += a.amount; else { auto += a.amount; titres.add(app.title || ''); }
      }
    }
    for (const a of panier.cart_level_discount_applications || []) {
      if (a.type === 'discount_code') code += a.total_allocated_amount; else { auto += a.total_allocated_amount; titres.add(a.title || ''); }
    }
    const codeApplique = code > 0;
    if (!auto && !codeApplique) { retirer(); return; }
    /* le pourcentage affiché est celui de la remise (son titre), pas un ratio dilué par l'échantillon */
    const pcts = [...titres].map((x) => (x.match(/(\d+)\s*%/) || [])[1]).filter(Boolean);
    const pctAuto = pcts.length === 1 ? Number(pcts[0]) : (base ? Math.round((auto / base) * 100) : O.pct);
    const grandsMurs = [...titres].some((x) => /grands murs/i.test(x));
    poser(encart, { lieu: 'panier', base, auto, pctAuto, grandsMurs, codeApplique, code, pour: '' });
  };

  document.addEventListener('click', async (ev) => {
    const b = ev.target.closest('[data-mb-av-appliquer]');
    if (!b) return;
    b.setAttribute('aria-busy', 'true');
    try { await fetch('/discount/' + encodeURIComponent(O.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }); } catch (x) {}
    location.reload();
  });
  const maj = () => { fiche(); panierCarte(); };
  document.addEventListener('mb:bienvenue', () => setTimeout(maj, 50));
  maj();
  setInterval(maj, 1000);
  if (/^\/cart/.test(location.pathname)) { lirePanier().then(maj); setInterval(() => lirePanier().then(maj), 4000); }
})();
/* 15/10 (Marcel) : un parcours d'achat qui commence sans prix et finit par « Vos avantages exclusifs ».
   En tête : une phrase sur la qualité, plus de bandeau promo ; le prix « dès 69 € / m² » reste en une ligne discrète (Merchant Center). Pendant le parcours : plus de pastille
   de prix sur le mur ni de prix dans le résumé de l'étape 5. À la fin : la carte remplace le total, les preuves et
   « Les attentions de la Maison ». Affichage seulement. */
(() => {
  if (!window.mbOffre || !window.mbOffre.active()) return;
  const st = document.createElement('style');
  st.textContent = '.mb-atelier__tete .mb-offre-ruban,.mb-atelier__tete .mb-atelier__detail,.mb-atelier__tete .mb-achat__artiste{display:none!important}'
    /* 15/10 (Marcel) : une seule ligne de prix discrète en tête, « dès 69 € / m² », visible pour Google Merchant Center */
    + '.mb-atelier__tete .mb-atelier__prix{margin:10px 0 0}.mb-atelier__tete .mb-atelier__montant{margin:0;font-size:15px;font-weight:400;color:var(--mb-gris,#6B665E)}'
    + '.mb-atelier__tete .mb-atelier__montant *{font-size:inherit!important;font-weight:inherit!important}'
    + '.mb-cadreur__pastille{display:none!important}.mb-cadreur__achat .mb-pas__resume{display:none!important}'
    + 'mb-cadreur.mb-carte-ok .mb-final .mb-final__prix,mb-cadreur.mb-carte-ok .mb-final .mb-cadreur__total,.mb-final .mb-attentions,.mb-final .mb-preuves{display:none!important}'
    + '.mb-final .mb-offre-encart{margin:24px 0 8px}'
    + '.mb-qualite-ligne{margin:10px 0 4px;font-size:15px;line-height:1.45;color:#417153;max-width:46ch}';
  document.head.appendChild(st);
  const t = document.querySelector('mb-cadreur .mb-atelier__tete');
  const titre = t && t.querySelector('.mb-achat__titre');
  if (titre && !t.querySelector('.mb-qualite-ligne')) {
    const q = document.createElement('p');
    q.className = 'mb-qualite-ligne';
    q.textContent = 'La qualité Maison Byōbu : des papiers peints d’exception, sans PVC, imprimés à vos mesures exactes.';
    titre.before(q);
  }
})();
